module.exports = __webpack_public_path__ + "static/img/portal.bea89d1f.jpg";